import { ActionReducer } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppStartupContext } from "@obg/ngx.core";
import { CoreContentState, MenuAction, MenuItem, TranslationAction } from "@obg/ngx.core.content";
import { FetchSuccessPayload } from "@obg/ngx.core.content/src/menu/menu.model";

const EXPERIMENT_KEY = "reveal-content-keys";

/** @internal */
export function _provideRevealContentKeysExperiment(startupContext: AppStartupContext) {
	return (reducer: ActionReducer<CoreContentState>) => (state: CoreContentState, action: ActionWithPayload) => {
		if (!startupContext.activeExperiments.includes(EXPERIMENT_KEY)) {
			return reducer(state, action);
		}

		/** keys instead of translations */
		if (action.type === TranslationAction.get.type) {
			action.payload = [];
		}

		/** content keys instead of title */
		if (action.type === MenuAction.fetchSuccess.type) {
			const payload: FetchSuccessPayload = action.payload;

			payload.menus = Object.keys(payload.menus).reduce((acc, key) => {
				const group = acc[key];
				group.items = group.items.map(recurTitleChange);
				return acc;
			}, payload.menus);
		}

		return reducer(state, action);
	};
}

/**
 * @internal
 * @param {MenuItem} menuItem - The menu item to update.
 * @returns {MenuItem} - The updated menu items.
 */
function recurTitleChange(menuItem: MenuItem): MenuItem {
	if (Array.isArray(menuItem.children)) {
		menuItem.children = menuItem.children.map(recurTitleChange);
	}

	menuItem.title = menuItem.key;
	return menuItem;
}
